<app-template [disablebreadcrumb]=true
              [fullLayout]="true"
              [footerVisible]="true">

<div class="search-container">
  <div class="search-area">
    <div class="search-button" [@hide]='hide' (click)="search()" *ngIf="disable">Pesquisar</div>
    <input [@rotatedState]='state' [(ngModel)]="textSearch"  minlength="3" *ngIf="disable">
    <div class="search-img" (click)="showHide()">
      <div [innerHTML]="colorService.svgList[imageName].htmlText" class="search-svg"></div>
    </div>
  </div>
  <div class="{{classMsg}}" *ngIf="showMessage">
    <div class="message" [ngStyle]="{'background-color': wasFound ? '#316b31' : '#a83838'}">
      <strong>{{searchMessage}}</strong>
      <div class="close" (click)="closeMessage()" >x</div>
    </div>
  </div>

</div>

<div class="filter-container">
  <div class="button-container">
    <div class="button">
      <input id="check1" type="checkbox" [(ngModel)]="checkRegion" name="menu"/>
      <label for="check1" *ngIf="regionalization">
        {{regionName}}
        <span class="arrow"></span>
      </label>
      <div class="submenu">
        <div class="close" (click)="closeSubMenu('region')">x</div>
        <label class="container check-all" *ngIf="localityDropdow?.length > 0" >
          <input type="checkbox" [(ngModel)]="selectAllLocalities" (change)="toggleAllLocalities()">
          <span [ngClass]="(partiallySelected(localityDropdow)) ? 'checkmark checkmark-mid' : 'checkmark checkmark-all'"></span>
        </label>
        <label class="container" *ngFor="let item of localityDropdow" >
            {{item.label}}
            <input type="checkbox" [(ngModel)]="item.check" (change)="LocalitiesSelected(item)">
            <span class="checkmark"></span>
        </label>
      </div>
    </div>

    <div class="button">
      <input id="check2" type="checkbox" [(ngModel)]="checkLocality" name="menu"/>
      <label for="check2">
        {{itemName}}
        <span class="arrow"></span>
      </label>
      <div class="submenu">
        <div class="close" (click)="closeSubMenu('locality')" >x</div>
        <label class="container check-all" *ngIf="planItemDropdow?.length > 0" >
          <input type="checkbox" [(ngModel)]="selectAllPlanItems" (change)="toggleAllItems()">
          <span [ngClass]="(partiallySelected(planItemDropdow)) ? 'checkmark checkmark-mid' : 'checkmark checkmark-all'"></span>
        </label>
        <label class="container" *ngFor="let item of planItemDropdow" >
            {{item.label}}
            <input type="checkbox" [(ngModel)]="item.check" (change)="planItemSelect(item)">
            <span class="checkmark"></span>
        </label>
      </div>
    </div>
  </div>
</div>

<div class="proposals-area-container" (scroll)="onScroll($event)">
  <div class="cards-container">
    <div *ngIf="listProposals?.length === 0" class="no-proposal-msg">Nenhuma proposta encontrada</div>
    <div class="card-item" *ngFor="let item of listProposals; let i = index" >

        <div class="proposal">
          <div class="quote">
            <div [innerHTML]="colorService.svgList.quote2_svg.htmlText" class="quote-svg"></div>
          </div>

          <div class="comment"><strong>{{ item.comment }}</strong></div>

          
          <div class="localityCity">{{ item.localityName }}</div>
          <div class="how-long-ago">{{ howLongAgo(item.time) }}</div>

          <a [ngClass]= "item.isLiked ? 'likes likesAfter' : 'likes likesBefore'"
            [class.disable-anchor-tag]="isMyComment(item)"

            (click)="likeProposal(i, item)" id="{{i}}">
            <div class="number">{{ item.likes || 0}}</div>
            <div [innerHTML]="colorService.svgList.like2_svg.htmlText" class="like-svg"></div>
          </a>
        </div>

        <div class="planitens">
          <div class="p-item" *ngIf="regionalization">

            <div class="image">
              <div class="planItem">
                <div [innerHTML]="colorService.svgList.locality_without_map_gradient_svg.htmlText" class="locality-svg"></div>
              </div>
              <p>Microrregião</p>
            </div>

            <div class="nameItem">
              {{item.localityMicro}}
            </div>
          </div>

          <div class="p-item" *ngFor="let planitem of item.planItens">
            <div class="image">
              <div class="planItem">
                <div [innerHTML]="colorService.svgList[planitem.fileName + '_svg'].htmlText" class="planItem-svg"></div>
              </div>
                <p>{{planitem.structureItemName}}</p>
              </div>
            <div class="nameItem">
              {{planitem.name}}
            </div>
          </div>

        </div>
    </div>
  </div>
</div>
</app-template>
